<div class="card mb-6" >
    <p-toast></p-toast>
    <p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
    <p-table
        #dt
        [value]="data"
        dataKey="id"
        editMode="row"
        [tableStyle]="{'min-width': '50rem'}"
        [paginator]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [rowsPerPageOptions]="[10, 25, 50]"
        [styleClass]="'p-datatable-sm'"
        [globalFilterFields]="getGlobalFilters()"
    >
        <ng-template pTemplate="caption">
            <div class="row">
                <div class="col-md-12 text-center">
                    <h4 class="mt-2">{{ label }}</h4>
                </div>
            </div>
            <div class="row">
                <div class="flex col-md-6">
                    <span class="p-input-icon-left ml-auto">
                        <i class="pi pi-search"></i>
                        <input [(ngModel)]="searchField" pInputText type="text" class="p-inputtext-sm" (input)="applyGlobalFilter($event, dt)" placeholder="Search" />
                    </span>
                </div>
                <div class="col-md-6 text-right">
                    <p-button icon="pi pi-plus" styleClass="p-button-sm" [label]="'Add ' + label" (click)="addEditRecord(false)"></p-button>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th
                    *ngFor="let field of model"
                    pSortableColumn="{{field.key}}"
                    style="width: {{ cellWidth }}%"
                >
                    {{ field.label }} <p-sortIcon field="{{ field.key }}"></p-sortIcon>
                </th>
                <th>Actions</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-editing="editing" let-ri="rowIndex" let-showSelect="showSelect">
            <tr [pEditableRow]="row">
                <td *ngFor="let field of model">
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input
                                *ngIf="!field.type"
                                pInputText
                                type="text"
                                [(ngModel)]="row[field.key]"
                                [disabled]="field.disabled"
                            >
                            <p-dropdown
                                *ngIf="field.type === 'select'"
                                [options]="field.options"
                                appendTo="body"
                                [(ngModel)]="row[field.key]"
                                [style]="{'width':'100%'}"
                                (onChange)="onChange($event, field, row)"
                            >
                            </p-dropdown>
                        </ng-template>
                        <ng-template pTemplate="output" *ngIf="field.isLink?.enable && field.getValue(field, row) !== 'null' && field.getValue(field, row) !== null">
                            <!-- Button just opens overlay -->
                            <p-button 
                                label="{{field.isLink.label}}" 
                                icon="{{ field.isLink.icon }}" 
                                (click)="onOpenLink(field.isLink, field.getValue(field, row), op, $event)">
                            </p-button>

                            <p-overlayPanel #op [showCloseIcon]="true" [style]="{width: 'field.isLink.width'}">
                                <ng-template pTemplate>
                                <p-table 
                                    [value]="integrationExtraDataList" 
                                    [rows]="10" 
                                    [paginator]="false" 
                                    responsiveLayout="scroll">
                                    
                                    <ng-template pTemplate="header">
                                    <tr>
                                        <th>Key</th>
                                        <th>Value</th>
                                    </tr>
                                    </ng-template>

                                    <ng-template pTemplate="body" let-rowData>
                                    <tr>
                                        <td>{{ rowData.key }}</td>
                                        <td>{{ rowData.value }}</td>
                                    </tr>
                                    </ng-template>
                                </p-table>
                                </ng-template>
                            </p-overlayPanel>
                        </ng-template>
                        <ng-template pTemplate="output" *ngIf="!field.isLink?.enable">
                            {{ field.getValue(field, row) }}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td>
                    <div class="flex align-items-center justify-content-center gap-2">
                        <button *ngIf="!editing && integrationExtraData?.showSelect" pButton pRipple type="button" icon="pi pi-arrow-right" (click)="onRowAction('goTo', row)" class="p-button-rounded p-button-text"></button>
                        <button *ngIf="!editing && !integrationExtraData.editInModal" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(row)" class="p-button-rounded p-button-text"></button>
						<button *ngIf="!editing && integrationExtraData.editInModal" pButton pRipple type="button" icon="pi pi-pencil" (click)="onRowEditInit(row)" class="p-button-rounded p-button-text"></button>
                        <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" (click)="onRowEditSave(row)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
                        <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onRowEditCancel(row, ri)" class="p-button-rounded p-button-text p-button-danger"></button>
                        <button *ngIf="!editing" pButton pRipple type="button" icon="pi pi-trash" (click)="onShowDeleteConfirm(row)" class="p-button-rounded p-button-text p-button-danger"></button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
